import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { KnowledgeManagementTagsService } from './service/knowledge-management-tags.service';
import { knowledgeManagementTagsInterface } from 'src/app/util/interfaces/knowledgeManagementTags';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { faAngleRight, faPen, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-knowledge-management-tags',
	templateUrl: './knowledge-management-tags.component.html',
	styleUrl: './knowledge-management-tags.component.scss',
})
export class KnowledgeManagementTagsComponent implements OnInit {
	icons = {
		faPlus: faPlus,
		faTimes: faTimes,
		faAngleRight: faAngleRight,
		faPen: faPen,
	};

	labels: LabelsInterface = {
		lbl_criar_novo_item: '',
		lbl_geral_atualizar: '',
		lbl_geral_excluir: '',
		lbl_geral_deletado_com_sucesso: '',
		lbl_geral_criado_com_sucesso: '',
		lbl_successful_updated: '',
		lbl_nao_pode_deletar_tag_com_filhos: '',
		lbl_tags_arvore_conhecimento: '',
	};

	//Configs
	@Input()
	hideTitle = false;

	@Input()
	canEdit = true;

	@Input()
	canAdd = true;

	@Input()
	customerList = '';

	@Input()
	selectOnlyLast = false;

	@Output()
	getSelectedTags = new EventEmitter();

	constructor(
		private LabelsService: LabelsService,
		private KnowledgeManagementTagsService: KnowledgeManagementTagsService,
		private NotificationService: NotificationService,
		private ProfileService: ProfileService
	) {
		this.getThreeShownTagCols = this.getThreeShownTagCols.bind(this);
	}

	userLanguage = 'english';

	isLoadingTags = true;
	isLoadingLabels = true;
	isLoadingNextLevel = false;
	isLoadingRegister = false;

	isRegisterOpen = false;
	triggerAreRequiredFulfilled = false;

	registerForm: genericFormInterface[] = [
		{
			name: 'name',
			label: 'lbl_geral_nome',
			inputType: 'string',
			values: [''],
			rawValues: [''],
			required: true,
		},
		{
			name: 'portuguese',
			label: 'lbl_geral_portugues',
			inputType: 'string',
			values: [''],
			rawValues: [''],
			required: true,
		},
		{
			name: 'english',
			label: 'lbl_geral_ingles',
			inputType: 'string',
			values: [''],
			rawValues: [''],
			required: true,
		},
		{
			name: 'spanish',
			label: 'lbl_geral_espanhol',
			inputType: 'string',
			values: [''],
			rawValues: [''],
			required: true,
		},
		{
			name: 'slovak',
			label: 'lbl_geral_eslovaco',
			inputType: 'string',
			values: [''],
			rawValues: [''],
			required: true,
		},
		{
			name: 'chinese',
			label: 'lbl_geral_chines',
			inputType: 'string',
			values: [''],
			rawValues: [''],
			required: true,
		},
		{
			name: 'italian',
			label: 'lbl_geral_italiano',
			inputType: 'string',
			values: [''],
			rawValues: [''],
			required: true,
		},
		{
			name: 'parent_id',
			label: 'parent_id',
			inputType: 'string',
			values: [''],
			rawValues: [''],
			hidden: true,
		},
		{
			name: 'depth',
			label: 'depth',
			inputType: 'string',
			values: [''],
			rawValues: [''],
			hidden: true,
		},
		{
			name: 'id',
			label: 'id',
			inputType: 'string',
			values: [''],
			rawValues: [''],
			hidden: true,
		},
	];
	registerFormDictionary = {};

	tags: knowledgeManagementTagsInterface[] = [];

	//showingTags será apenas o nível de profundidade atual e o anterior;
	shownTags: knowledgeManagementTagsInterface[][] = [];
	selectedTags: knowledgeManagementTagsInterface[] = [];

	ngOnInit(): void {
		for (const formItem of this.registerForm) {
			this.registerFormDictionary[formItem.name] = formItem;
		}

		this.userLanguage = this.ProfileService.userData().language.toLowerCase();
		if (this.customerList == '') this.customerList = this.ProfileService.userData().idCustomer;

		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.KnowledgeManagementTagsService.getTags(this.customerList, undefined, 0).subscribe((tags) => {
			this.tags = tags;
			this.shownTags.push(tags);
			this.isLoadingTags = false;
		});
	}

	getThreeShownTagCols(tagCol: knowledgeManagementTagsInterface[]) {
		return this.shownTags.indexOf(tagCol) > this.shownTags.length - 4 ? true : false;
	}

	openRegister(tagDepth: number, selectedTag?: knowledgeManagementTagsInterface): void {
		this.registerFormDictionary['depth'].values[0] = tagDepth;
		if (tagDepth - 1 >= 0) {
			for (let index = 0; index < this.shownTags[tagDepth - 1].length; index++) {
				const tag = this.shownTags[tagDepth - 1][index];
				if (tag.selected != true) continue;
				this.registerFormDictionary['parent_id'].values[0] = tag.id;
				break;
			}
		} else this.registerFormDictionary['parent_id'].values[0] = '';
		if (selectedTag == undefined) {
			this.cleanRegister();
		} else {
			this.registerFormDictionary['name'].values[0] = selectedTag.name;
			this.registerFormDictionary['portuguese'].values[0] = selectedTag.portuguese;
			this.registerFormDictionary['english'].values[0] = selectedTag.english;
			this.registerFormDictionary['spanish'].values[0] = selectedTag.spanish;
			this.registerFormDictionary['slovak'].values[0] = selectedTag.slovak;
			this.registerFormDictionary['chinese'].values[0] = selectedTag.chinese;
			this.registerFormDictionary['italian'].values[0] = selectedTag.italian;
			this.registerFormDictionary['parent_id'].values[0] = selectedTag.parent_id;
			this.registerFormDictionary['id'].values[0] = selectedTag.id;
		}
		this.isRegisterOpen = true;
	}

	cleanRegister(): void {
		this.registerFormDictionary['name'].values[0] = '';
		this.registerFormDictionary['portuguese'].values[0] = '';
		this.registerFormDictionary['english'].values[0] = '';
		this.registerFormDictionary['spanish'].values[0] = '';
		this.registerFormDictionary['slovak'].values[0] = '';
		this.registerFormDictionary['chinese'].values[0] = '';
		this.registerFormDictionary['italian'].values[0] = '';
		this.registerFormDictionary['id'].values[0] = '-1';
	}

	areRequiredFieldsFulfilled(): boolean {
		let areRequiredFieldsFulfilled = true;
		for (let index = 0; index < this.registerForm.length; index++) {
			const formItem = this.registerForm[index];
			if (
				formItem.required == true &&
				formItem.hidden != false &&
				(formItem.values[0] == '' || formItem.values[0] == '-1' || formItem.values[0] == undefined)
			) {
				areRequiredFieldsFulfilled = false;
				break;
			}
		}

		return areRequiredFieldsFulfilled;
	}

	addTag(): void {
		if (this.isLoadingRegister) return;

		if (this.areRequiredFieldsFulfilled() == false) {
			this.triggerAreRequiredFulfilled = true;
			setTimeout(() => {
				this.triggerAreRequiredFulfilled = false;
			}, 100);

			return;
		}

		this.isLoadingRegister = true;

		const newTag: knowledgeManagementTagsInterface = {
			id: -1,
			name: this.registerFormDictionary['name'].values[0],
			portuguese: this.registerFormDictionary['portuguese'].values[0],
			english: this.registerFormDictionary['english'].values[0],
			spanish: this.registerFormDictionary['spanish'].values[0],
			slovak: this.registerFormDictionary['slovak'].values[0],
			chinese: this.registerFormDictionary['chinese'].values[0],
			italian: this.registerFormDictionary['italian'].values[0],
			parent_id: this.registerFormDictionary['parent_id'].values[0],
			depth: this.registerFormDictionary['depth'].values[0],
			childTags: [],
			expanded: false,
			isLeaf: true,
			selected: false,
			lastSelected: false,
			customer_id: this.ProfileService.userData().idCustomer,
		};

		this.KnowledgeManagementTagsService.addTag(newTag).subscribe(
			(res) => {
				newTag.id = res.id;
				this.shownTags[this.registerFormDictionary['depth'].values[0]].push(newTag);
				if (this.registerFormDictionary['depth'].values[0] > 0) {
					for (let index = 0; index < this.shownTags[this.registerFormDictionary['depth'].values[0] - 1].length; index++) {
						const tag = this.shownTags[this.registerFormDictionary['depth'].values[0] - 1][index];
						if (tag.selected != true) continue;
						tag.isLeaf = false;
						break;
					}
				}
				this.isLoadingRegister = false;
				this.isRegisterOpen = false;
				this.getSelectedTags.emit(this.selectedTags);
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_criado_com_sucesso);
			},
			() => {
				this.getSelectedTags.emit(this.selectedTags);
				this.isLoadingRegister = false;
			}
		);
	}

	updateTag(): void {
		if (this.isLoadingRegister) return;
		this.isLoadingRegister = true;

		const updatedTag: knowledgeManagementTagsInterface = {
			id: this.registerFormDictionary['id'].values[0],
			name: this.registerFormDictionary['name'].values[0],
			portuguese: this.registerFormDictionary['portuguese'].values[0],
			english: this.registerFormDictionary['english'].values[0],
			spanish: this.registerFormDictionary['spanish'].values[0],
			slovak: this.registerFormDictionary['slovak'].values[0],
			chinese: this.registerFormDictionary['chinese'].values[0],
			italian: this.registerFormDictionary['italian'].values[0],
			parent_id: this.registerFormDictionary['parent_id'].values[0],
			depth: this.registerFormDictionary['depth'].values[0],
			childTags: [],
			expanded: false,
			isLeaf: true,
			selected: false,
			lastSelected: false,
			customer_id: this.ProfileService.userData().idCustomer,
		};

		this.isLoadingRegister = true;
		this.KnowledgeManagementTagsService.updateTag(updatedTag).subscribe(
			(res) => {
				const tag = this.selectedTags[this.registerFormDictionary['depth'].values[0]];
				tag.name = updatedTag.name;
				tag.portuguese = updatedTag.portuguese;
				tag.english = updatedTag.english;
				tag.spanish = updatedTag.spanish;
				tag.slovak = updatedTag.slovak;
				tag.chinese = updatedTag.chinese;
				tag.italian = updatedTag.italian;

				this.isLoadingRegister = false;
				this.isRegisterOpen = false;
				this.getSelectedTags.emit(this.selectedTags);
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
			},
			() => {
				this.getSelectedTags.emit(this.selectedTags);
				this.isLoadingRegister = false;
			}
		);
	}

	deleteTag(): void {
		if (this.isLoadingRegister) return;

		if (this.shownTags[this.registerFormDictionary['depth'].values[0] + 1].length > 0) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_nao_pode_deletar_tag_com_filhos);
			return;
		}

		this.isLoadingRegister = true;
		this.KnowledgeManagementTagsService.deleteTag(this.registerFormDictionary['id'].values[0]).subscribe(
			(res) => {
				for (let index = 0; index < this.shownTags[this.registerFormDictionary['depth'].values[0]].length; index++) {
					const tag = this.shownTags[this.registerFormDictionary['depth'].values[0]][index];
					if (tag.selected != true) continue;
					this.shownTags[this.registerFormDictionary['depth'].values[0]].splice(index, 1);
					break;
				}
				this.selectedTags.pop();
				this.shownTags.pop();
				this.isLoadingRegister = false;
				this.isRegisterOpen = false;
				this.getSelectedTags.emit(this.selectedTags);
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_deletado_com_sucesso);
			},
			() => {
				this.getSelectedTags.emit(this.selectedTags);
				this.isLoadingRegister = false;
			}
		);
	}

	expandTag(selectedTag: knowledgeManagementTagsInterface, depth: number): void {
		if (this.isLoadingNextLevel) return;

		this.rollbackTo(depth, true, false);

		selectedTag.selected = true;
		if (depth != 0) this.selectedTags.at(-1).lastSelected = false;
		selectedTag.lastSelected = true;
		this.selectedTags.push(selectedTag);

		if (selectedTag.isLeaf == true) {
			this.shownTags.push([]);
			this.getSelectedTags.emit(this.selectedTags);
			return;
		}

		this.isLoadingNextLevel = true;
		this.KnowledgeManagementTagsService.getTags(this.customerList, selectedTag.id).subscribe(
			(tagCol) => {
				this.shownTags.push(tagCol);

				this.getSelectedTags.emit(this.selectedTags);
				this.isLoadingNextLevel = false;
			},
			() => {
				this.getSelectedTags.emit(this.selectedTags);
				this.isLoadingNextLevel = false;
			}
		);
	}

	rollbackTo(depth: number, unselectThisCol: boolean, emit?: boolean): void {
		if (this.isLoadingNextLevel) return;
		for (let index = this.shownTags.length - 1; index >= depth + 1; index--) {
			for (const tag of this.shownTags[index]) {
				tag.selected = false;
				tag.lastSelected = false;
			}
			this.shownTags.pop();
			this.selectedTags.pop();
		}

		if (unselectThisCol) {
			for (const tag of this.shownTags[depth]) {
				tag.selected = false;
				tag.lastSelected = false;
			}
		}
		if (emit == true) this.getSelectedTags.emit(this.selectedTags);
	}
}
